const rawRegimenMap = {
  'SOLO ALOJAMIENTO': 'Solo Alojamiento',
  'SÓLO ALOJAMIENTO': 'Solo Alojamiento',
  DESAYUNO: 'Desayuno',
  'DESAYUNO CONTINENTAL': 'Desayuno',
  'DESAYUNO BUFFET': 'Desayuno',
  'DESAYUNO AMERICANO': 'Desayuno',
  'PENSIÓN COMPLETA': 'Pensión Completa',
  'PENSION COMPLETA': 'Pensión Completa',
  'MEDIA PENSIÓN': 'Media Pensión',
  'MEDIA PENSION': 'Media Pensión',
  'TODO INCLUIDO': 'Todo Incluido',
  'TODO INCLUÍDO': 'Todo Incluido',
  'PAQUETE DISNEY': 'Paquete Disney',
  'PAQUETES DISNEY': 'Paquete Disney',
};

export const REGIMEN_ORDER = [
  'Solo Alojamiento',
  'Desayuno',
  'Media Pensión',
  'Pensión Completa',
  'Todo Incluido',
  'Paquete Disney',
];

const normalizeText = text =>
  text
    ?.toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const regimenMap = Object.entries(rawRegimenMap).reduce((acc, [key, value]) => {
  acc[normalizeText(key)] = value;
  return acc;
}, {});

export const normalizeRegimen = reg => {
  const normalized = normalizeText(reg);
  const mapped = regimenMap[normalized];
  return {
    label: mapped || normalized,
    isCustom: !mapped,
  };
};

export const buildRegimenList = (hotelSearchResults, baseFilters = []) => {
  const filters = [...baseFilters];

  hotelSearchResults.forEach(hotel => {
    hotel.rates.forEach(rate => {
      const description = rate.board?.description?.split('(')?.[0]?.trim();
      if (!description) {
        return;
      }

      const { label, isCustom } = normalizeRegimen(description);

      const existing = filters.find(f => f.type === label);

      if (existing) {
        existing.state = true;
      } else {
        filters.push({
          type: label,
          state: true,
          isCustom,
        });
      }
    });
  });

  return filters;
};
